import React from "react";
import { Ripple } from "primereact/ripple";
import { Tooltip } from "primereact/tooltip";

interface TableButtonProps {
    label?: string;
    icon?: string;
    onClick: () => void;
    className?: string;
    iconClassName?: string;
    disabled?: boolean;
    tooltip?: string;
    tooltipPosition?: 'top' | 'bottom' | 'left' | 'right' | 'mouse';
    tooltipTarget?: string;
}

const TableButton: React.FC<TableButtonProps> = ({
    label,
    icon,
    onClick,
    className,
    iconClassName,
    disabled,
    tooltip,
    tooltipPosition = 'top',
    tooltipTarget
}) => {
    return (
        <React.Fragment>
            <Tooltip target={`.${tooltipTarget}`} />

            <button
                type="button"
                className={`tabel_btn p-ripple ${className ?? ''} ${tooltipTarget ?? ''}`}
                onClick={onClick}
                disabled={disabled}
                data-pr-position={tooltipPosition}
                data-pr-tooltip={tooltip}
            >
                <i className={`${icon ? icon : ''} ${iconClassName ? iconClassName : ''}`}></i>
                {label ? label : ''}
                <Ripple />
            </button>
        </React.Fragment>
    )
}

export default TableButton;